import { SecureDocumentsClient } from '@mhub/securedocuments-sdk-js';
import Auth from '@aws-amplify/auth';
import config from '../../config';

export const sdsClient = new SecureDocumentsClient({
  baseURL: config.get('secureDocumentsApiURL'),
  cfDistributionURL: config.get('secureDocumentsBoxURL'),
  bearerToken: async () => {
    try {
      return (await Auth.currentSession()).getAccessToken().getJwtToken();
    } catch (err) {
      return '';
    }
  },
});



// WEBPACK FOOTER //
// ./src/actions/secureDocumentsClient.js